import BaseEvent, {
  BaseGetEvent,
  IBaseEvent,
} from 'hooks/context/EventCollector/events/BaseEvent';

export interface ICalculatorEvent extends IBaseEvent {
  type: 'calculator';
  toJSON(): BaseGetEvent & {
    type: ICalculatorEvent['type'];
    value: number;
  };
}

export default class CalculatorEvent
  extends BaseEvent
  implements ICalculatorEvent
{
  type = 'calculator' as const;

  private value: number;

  constructor({ description, value }: { description: string; value: number }) {
    super(description);
    this.value = value;
  }

  override toJSON() {
    return {
      ...super.toJSON(),
      type: this.type,
      value: this.value,
    };
  }
}
